
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      default: () => ['微信登录', '手机号登录']
    },
    tabIdx: {
      type: Number,
      default: 0
    }
  },
  setup(_props, { emit }) {
    function toggleTab(idx: number) {
      emit('toggleTab', idx)
    }

    return {
      toggleTab
    }
  }
}
